import { useState } from "react";
import { AtSign } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";

export const AliasCard = ({ alias, onDone }) => {
  const [v, setV] = useState(alias || "");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try { await api.put("/me/alias", { alias: v }); toast.success("Alias updated"); onDone(); }
    catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  return (
    <div data-testid="alias-card" className="lux-card p-5 mt-6 flex flex-col sm:flex-row sm:items-center gap-4">
      <AtSign className="w-5 h-5 text-[#38BDF8] shrink-0" />
      <div className="flex-1 text-sm">
        <p className="font-semibold">Your public alias</p>
        <p className="text-slate-400 text-xs mt-0.5">Other members only ever see this alias in the line and on the Voyagers page, never your real name.</p>
      </div>
      <input data-testid="alias-input" value={v} onChange={(e) => setV(e.target.value)} maxLength={24} className="lux-input !py-2 sm:max-w-[220px]" />
      <button data-testid="alias-save-btn" disabled={busy || v.trim().length < 3 || v === alias} onClick={save} className="btn-ghost px-4 py-2 text-sm">Save</button>
    </div>
  );
};
